import ContactUsView from './ContactUs';
import FAQsView from './FAQs';
import GameGuidelinesView from './GameGuidelines';
import PrizesView from './Prizes';
import TermsAndConditionsView from './TermsAndConditions';
import WhatsNewView from './WhatsNew';
import DraftGameGuidelinesView from './DraftGameGuidelines';
import FantasyCoachView from './FantasyCoach';

export { ContactUsView };
export { FAQsView };
export { GameGuidelinesView };
export { PrizesView };
export { TermsAndConditionsView };
export { WhatsNewView };
export { DraftGameGuidelinesView };
export { FantasyCoachView }

export default {
	ContactUsView,
	FAQsView,
	GameGuidelinesView,
	PrizesView,
	TermsAndConditionsView,
	WhatsNewView,
	DraftGameGuidelinesView,
	FantasyCoachView
}